import authReducer from './Reducers/authReducer'
import categoryReducer from './Reducers/categoryReducer'
import productReducer from './Reducers/productReducer'
import sellerReducer from './Reducers/sellerReducer'
import customerReducer from './Reducers/customerReducer'
import chatReducer from './Reducers/chatReducer'
import OrderReducer from './Reducers/OrderReducer'
import PaymentReducer from './Reducers/PaymentReducer'
import dashboardIndexReducer from './Reducers/dashboardIndexReducer'
import bannerReducer from './Reducers/bannerReducer'
import staffReducer from './Reducers/staffReducer'
import supportReducer from './Reducers/supportReducer'
import referralReducer from './Reducers/referralReducer'
import cartAbandonmentReducer from './Reducers/cartAbandonmentReducer'
import escrowReducer from './Reducers/escrowReducer'
import returnReducer from './Reducers/returnReducer'
import installmentReducer from './Reducers/installmentReducer'

const rootReducer = {
    auth: authReducer,
    category: categoryReducer,
    product: productReducer,
    seller: sellerReducer,
    customer: customerReducer,
    chat: chatReducer,
    order: OrderReducer,
    payment: PaymentReducer,
    dashboardIndex: dashboardIndexReducer,
    banner : bannerReducer,
    staff: staffReducer,
    support: supportReducer,
    referral: referralReducer,
    cartAbandonment: cartAbandonmentReducer,
    escrow: escrowReducer,
    return: returnReducer,
    installment: installmentReducer
}
export default rootReducer